import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-install-banner',
  imports: [],
  templateUrl: './app-install-banner.html',
  styleUrl: './app-install-banner.scss',
})
export class AppInstallBanner {
  @Input() show = false;
  @Input() isIOS = false;
  @Input() isAndroid = false;

  @Output() dismissed = new EventEmitter<{ forever: boolean }>();

  neverShow = false;

  /** Backdrop click: just close, no flag */
  dismissBackdrop() {
    this.dismissed.emit({ forever: false });
  }

  /** X button: respects neverShow toggle */
  dismissSession() {
    this.dismissed.emit({ forever: this.neverShow });
  }

  /** Store link clicked */
  dismissForever() {
    this.dismissed.emit({ forever: true });
  }
}
